import gsap from 'gsap/all'
import ScrollTrigger from 'gsap/ScrollTrigger'

export default function() {
  const sections = document.querySelectorAll('.projects-section')

  sections.forEach(section => {
    // Animation
    ScrollTrigger.batch(
      section.querySelectorAll('.projects-type-wrapp li, .project-item'),
      {
        start: 'top bottom-=10%',
        end: 'top bottom-=10%',
        once: true,
        onEnter: batch => {
          gsap.to(batch, {
            y: 0,
            opacity: 1,
            ease: 'basicEase',
            duration: 1,
            stagger: 0.1,
          })
        },
      }
    )

    const typeBtns = section.querySelectorAll('.project-type-btn')
    const cards = section.querySelectorAll(`.project-item`)

    typeBtns.forEach(btn => {
      btn.addEventListener('click', filter)
    })

    let lastFilter = null

    function filter() {
      if (this.getAttribute('type') === lastFilter) return

      typeBtns.forEach(item =>
        item !== this
          ? item.classList.remove('active')
          : item.classList.add('active')
      )

      const activeType = section
        .querySelector('.project-type-btn.active')
        .getAttribute('type')
      const activeCards = activeType
        ? section.querySelectorAll(`.project-item[type="${activeType}"]`)
        : cards
      const hiddenCards = activeType
        ? section.querySelectorAll(`.project-item:not([type="${activeType}"])`)
        : null

      gsap
        .timeline({
          defaults: {
            ease: 'basicEase',
            duration: 0.6,
          },
          onComplete: () => ScrollTrigger.refresh(),
        })
        .set(cards, {
          y: 0,
          opacity: 1,
        })
        .call(
          () => {
            if (hiddenCards) {
              hiddenCards.forEach(item => {
                item.classList.add('hidden')
              })
            }
            activeCards.forEach(item => {
              item.classList.remove('hidden')
            })
          },
          null,
          '<'
        )

      lastFilter = activeType
    }
  })
}
